import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PaulyOrderDto } from './dto/order.dto';

export interface CancelOrderRequest {
  orderIds: string[];
  reason?: string;
}

export interface CancelOrderResponse {
  success: boolean;
  cancelledOrderIds: string[];
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PaulyOrderService {
  constructor(private client: HttpClient) {}

  getOrder = (orderId: string) => this.client.get<PaulyOrderDto>(`/api/v1.0/orders/${orderId}`);

  cancelOrders = (request: CancelOrderRequest): Observable<CancelOrderResponse> =>
    this.client.post<CancelOrderResponse>(`/api/v1.0/orders/cancel`, request);
}
